import React from "react";
import { Link } from "react-router-dom";

const ShippingReturns = () => (
    <div data-testid="shipping-returns-page" className="bg-[#FAF9F6] min-h-screen">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-16 pb-24">
            <p className="label">Policy</p>
            <h1 className="font-serif text-5xl sm:text-6xl mt-5 text-[#1C1C1A] leading-none" data-testid="shipping-returns-heading">
                Shipping &amp; Returns
            </h1>

            <div className="mt-12 space-y-10 text-[#4A4A46] leading-relaxed">
                <section>
                    <h2 className="font-serif text-2xl text-[#1C1C1A] mb-4">Shipping</h2>
                    <p>Australian orders are charged a flat A$9.50 shipping rate.</p>
                    <p className="mt-4">
                        International shipping is A$20 for orders containing up to three soap bars to the countries currently available at checkout. Larger international orders and artisan soap slabs require a personalised shipping quote before payment.
                    </p>
                    <p className="mt-4">
                        International import duties, customs charges and local taxes are not included in the shipping charge and may be payable by the recipient.
                    </p>
                    <p className="mt-4">
                        Delivery addresses must be entered accurately at checkout. Please <Link className="alati-link" to="/contact">contact ALATI</Link> immediately if you notice an error.
                    </p>
                </section>

                <section>
                    <h2 className="font-serif text-2xl text-[#1C1C1A] mb-4">Returns</h2>
                    <p>
                        Because soap is a personal-use item, we cannot accept change-of-mind returns once a bar has been opened or used.
                    </p>
                    <p className="mt-4">
                        Please <Link className="alati-link" to="/contact">contact us</Link> if your order arrives damaged, incorrect or faulty. Nothing in this policy excludes or limits your rights under the Australian Consumer Law.
                    </p>
                </section>
            </div>
        </div>
    </div>
);

export default ShippingReturns;
